import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import {
  createChat,
  deleteChat,
  getChats,
  updateChat,
} from '../../../actions/chat';
import { useUser } from '../../../providers/UserContext';
import ChatBox from './ChatBox';
import LoadingMask from '../../shared/LoadingMask';
import ChatSelection from './ChatSelection';

function Chat() {
  const user = useUser();
  const [chats, setChats] = useState(null);
  const [activeChat, setActiveChat] = useState(null);

  useEffect(() => {
    if (user?.entity_id && !chats) {
      getChats()
        .then((data) => {
          data.sort(
            (a, b) =>
              new Date(b.updated_at).valueOf() -
              new Date(a.updated_at).valueOf()
          );
          setChats(data);
          setActiveChat(data[0]);
        })
        .catch((error) => console.log(error));
    }
  }, [user?.entity_id, chats]);

  useEffect(() => {
    if (user?.entity_id && chats && chats.length === 0) {
      createChat({ name: 'New Chat' })
        .then((chat) => {
          setChats([chat]);
          setActiveChat(chat);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [user?.entity_id, chats]);

  const handleUpdateChat = async (chat_id, update) => {
    const updated_chat = await updateChat(chat_id, update);
    console.log(updated_chat);
    setChats((prevChats) => {
      const index = prevChats.findIndex((chat) => chat.entity_id === chat_id);
      const new_chats = [...prevChats];
      new_chats[index] = updated_chat;
      return new_chats;
    });
    setActiveChat(updated_chat);
  };

  const handleDeleteChat = async (chat_id) => {
    await deleteChat(chat_id);
    const new_chats = [...chats].filter((chat) => chat.entity_id !== chat_id);
    if (new_chats.length) {
      setChats(new_chats);
      setActiveChat(new_chats[0]);
    } else {
      const new_chat = await createChat({ name: 'New Chat' });
      setChats([new_chat]);
      setActiveChat(new_chat);
    }
  };

  if (!chats) {
    return <LoadingMask />;
  }
  return (
    <Grid container>
      <Grid lg={2} md={2} xs={2}>
        <Box sx={{ padding: '15px' }}>
          <ChatSelection
            chats={chats}
            setActiveChat={setActiveChat}
            setChats={setChats}
          />
        </Box>
      </Grid>
      <Grid lg={10} md={10} xs={10}>
        <ChatBox
          key={activeChat?.updated_at}
          chat={activeChat}
          updateChat={handleUpdateChat}
          deleteChat={handleDeleteChat}
        />
      </Grid>
    </Grid>
  );
}

export default Chat;
